module.exports = __webpack_public_path__ + "static/mastodon-50de2ebbd612b19c0716beed5ea94ff0.png";